<template lang="pug">
  modal(@closeModal='closeModal' :title='$t("krea.addResourceLanguageModal.addLanguage")')
    .column
      k-select.input.text-normal.m-top-2.m4-bottom-11.language-select.dropdown-container(
        name='language'
        withBorder
        keyName='value'
        labelName='label'
        :placeholder='$t("krea.addResourceLanguageModal.chooseLanguage")'
        :options='languagesOptions'
        @selectOption='languageSelected'
      )
      .row.self-end
        button.secondary-button.white.m4-right-5(type='button' @click='closeModal')
          | {{ $t('krea.addResourceLanguageModal.cancel') }}
        button.primary-button.no-border(type='button' :disabled='!selectedLanguage' @click='submitSelectedLanguage')
          | {{ $t('krea.addResourceLanguageModal.addLanguage') }}
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Modal from '@/components/Modal'
import KSelect from '@/components/KSelect'
import { supportedLanguages } from '@/constants/languages'

export default {
  components: { Modal, KSelect },
  data() {
    return {
      selectedLanguage: ''
    }
  },
  computed: {
    ...mapState({
      modalProps: state => state.behavior.addKreaResourceLanguageModal.props
    }),
    languagesOptions() {
      return supportedLanguages
        .filter(item => !this.modalProps.languages.includes(item.lang))
        .map(item => ({
          label: `<div class='row'><img class='m4-right-2' src='${item.icon}'/><p class='text-normal'>${item.label}</p></div>`,
          value: item.lang
        }))
    }
  },
  methods: {
    ...mapActions([
      'showElement',
      'hideElement',
      'addLanguageKreaResource'
    ]),
    closeModal() {
      this.hideElement({ element: 'addKreaResourceLanguageModal' })
    },
    languageSelected(_, language) {
      this.selectedLanguage = language
    },
    async submitSelectedLanguage() {
      this.showElement({ element: 'fullPageLoader' })
      const success = await this.addLanguageKreaResource({ id: this.modalProps.id, locale: this.selectedLanguage })
      this.hideElement({ element: 'fullPageLoader' })
      this.hideElement({ element: 'addKreaResourceLanguageModal' })
      if (success) {
        this.$emit('addedLanguage', this.selectedLanguage)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.image {
  height: 120px;
}

.dropdown-container {
  --container-size: 240px;
}
</style>

<style lang="scss">
.language-select .options-container {
  max-width: initial;
}
</style>
